// UI設計書_0402.pdf 種類アイコンを番号付け
// 順番に意味はなく、ファイルのアルファベット順で採番した
export function getEquipmentIcon(
  iconNum?: number,
  status?: "on" | "off" | "all"
) {
  const res = {
    1: {
      on: "/images/icons/ic_furniture_alcohol_on.png",
      off: "/images/icons/ic_furniture_alcohol_off.png"
    },
    2: {
      on: "/images/icons/ic_furniture_backyard_on.png",
      off: "/images/icons/ic_furniture_backyard_off.png"
    },
    3: {
      on: "/images/icons/ic_furniture_chilled_1_on.png",
      off: "/images/icons/ic_furniture_chilled_1_off.png"
    },
    4: {
      on: "/images/icons/ic_furniture_chilled_2_on.png",
      off: "/images/icons/ic_furniture_chilled_2_off.png"
    },
    5: {
      on: "/images/icons/ic_furniture_cosmetics_on.png",
      off: "/images/icons/ic_furniture_cosmetics_off.png"
    },
    6: {
      on: "/images/icons/ic_furniture_dairy_on.png",
      off: "/images/icons/ic_furniture_dairy_off.png"
    },
    7: {
      on: "/images/icons/ic_furniture_dessert_on.png",
      off: "/images/icons/ic_furniture_dessert_off.png"
    },
    8: {
      on: "/images/icons/ic_furniture_drink_on.png",
      off: "/images/icons/ic_furniture_drink_off.png"
    },
    9: {
      on: "/images/icons/ic_furniture_energy-drink_on.png",
      off: "/images/icons/ic_furniture_energy-drink_off.png"
    },
    10: {
      on: "/images/icons/ic_furniture_frozen_on.png",
      off: "/images/icons/ic_furniture_frozen_off.png"
    },
    11: {
      on: "/images/icons/ic_furniture_fruit_on.png",
      off: "/images/icons/ic_furniture_fruit_off.png"
    },
    12: {
      on: "/images/icons/ic_furniture_hot-snack_on.png",
      off: "/images/icons/ic_furniture_hot-snack_off.png"
    },
    13: {
      on: "/images/icons/ic_furniture_ice_on.png",
      off: "/images/icons/ic_furniture_ice_off.png"
    },
    14: {
      on: "/images/icons/ic_furniture_medicine_on.png",
      off: "/images/icons/ic_furniture_medicine_off.png"
    },
    15: {
      on: "/images/icons/ic_furniture_obento_on.png",
      off: "/images/icons/ic_furniture_obento_off.png"
    },
    16: {
      on: "/images/icons/ic_furniture_onigiri_on.png",
      off: "/images/icons/ic_furniture_onigiri_off.png"
    },
    17: {
      on: "/images/icons/ic_furniture_outside-temperature_on.png",
      off: "/images/icons/ic_furniture_outside-temperature_off.png"
    },
    18: {
      on: "/images/icons/ic_furniture_side-dish_1_on.png",
      off: "/images/icons/ic_furniture_side-dish_1_off.png"
    },
    19: {
      on: "/images/icons/ic_furniture_side-dish_2_on.png",
      off: "/images/icons/ic_furniture_side-dish_2_off.png"
    },
    20: {
      on: "/images/icons/ic_furniture_store-temperature_on.png",
      off: "/images/icons/ic_furniture_store-temperature_off.png"
    },
    21: {
      on: "/images/icons/ic_furniture_sweets_on.png",
      off: "/images/icons/ic_furniture_sweets_off.png"
    },
    22: {
      on: "/images/icons/ic_furniture_vegetable_on.png",
      off: "/images/icons/ic_furniture_vegetable_off.png"
    }
  };
  if (status === "all") return res;
  if (!iconNum) return "";
  return res[iconNum as number][status];
}
